<template>
  <of-dialog
    title="联系管理员"
    :appendToBody="true"
    @onCancel="close"
    @onConfirm="confirm"
    confirmName="确 定"
  >
    <div slot="content" style="padding:10px;width:600px">
      <el-row :gutter="20">
        <el-col :span="4" style="text-align:center" >
          <img src="@/assets/images/group.png"  style="width:50%"/>
          <a class="btn btn-default" v-if="sendEmailLink" :href="sendEmailLink" style="position: relative;right:10px; margin-top: 20px;padding: 3px 10px;" size="mini"><i class="fa fa-envelope"></i>发送邮件</a>
        </el-col>
        <el-col :span="20">
      <el-table :data="listData" :show-header="false" stripe  >
        <el-table-column label="类型" width="120" prop="type"></el-table-column>
        <el-table-column label="类型" prop="content">
          <template slot-scope="scope">
            <div class="admin-content">{{scope.row.content}}</div>
          </template>
        </el-table-column>
      </el-table>
</el-col>
      </el-row>

      <!-- <div class="content-box-form form-horizontal">
        <div class="box-form-part" v-if="!adminInfo">
          <p>无相关信息</p>
        </div>
        <div class="box-form-part" v-if="adminInfo">
          <div class="form-group" v-show="adminInfo.BusinessAdminDescription">
            <label class="control-label col-xs-2">业务管理员</label>
            <div class="control-box col-xs-10">
              <p class="form-control-static admin-content">{{adminInfo.BusinessAdminDescription||'无'}}</p>
            </div>
          </div>

          <div class="form-group" v-show="adminInfo.SystemAdminDescription">
            <label class="control-label col-xs-2">系统管理员</label>
            <div class="control-box col-xs-10">
              <p class="form-control-static admin-content" >{{adminInfo.SystemAdminDescription||'无'}}</p>
            </div>
          </div>

          <div class="form-group"  v-show="adminInfo.OpsAdminDescription">
            <label class="control-label col-xs-2">系统负责人</label>
            <div class="control-box col-xs-10">
              <p class="form-control-static admin-content">{{adminInfo.OpsAdminDescription||'无'}}</p>
            </div>
          </div>
      </div>
    </div> -->

    </div>
    <div slot="footer-operation"></div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import {getAdminInfo} from "@/modules/sys/api/tenant.js"

export default {
  name: "sys-admin-info",
  props: {},
  data() {
    return {
      listData:[],
      sendEmailLink:''// javascript:void(0);
    };
  },
  components: {
    OfDialog
  },
  mounted() {
    getAdminInfo().then(x=>{
      if(x.data.Code==0){
        let adminInfo = x.data.Data
        if(adminInfo.BusinessAdminDescription)
          this.listData.push({type:'业务管理员',content:adminInfo.BusinessAdminDescription});
        if(adminInfo.SystemAdminDescription)
          this.listData.push({type:'系统管理员',content:adminInfo.SystemAdminDescription});
        if(adminInfo.OpsAdminDescription)
          this.listData.push({type:'系统负责人',content:adminInfo.OpsAdminDescription});

        if(adminInfo.OpsEmailSettings){
          let obj = JSON.parse(adminInfo.OpsEmailSettings)
          let cc = '';
          if(obj.cc&&obj.cc.length>0){
            cc = `&cc=${obj.cc.join(';')}`
          }
          this.sendEmailLink = `mailto:${obj.to.join(';')}${cc}&subject=${obj.subject}`
        }
          
      }
    })

  },
  methods: {
    close() {
      this.$emit("pickerCallBack", null);
    },
    confirm() {}
  }
};
</script>
<style scoped>
.admin-content{
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  *word-wrap: break-word;
  *white-space : normal ;  
}
</style>
